module.exports = __webpack_public_path__ + "static/media/replace.351c8932.webp";